import FieldSkeleton from '@forms/Components/FieldSkeleton';
import styles from './Form.module.css';
import { Skeleton } from '@mui/material';

interface FormSkeletonProps {
	extended?: boolean;
}

export default function FormSkeleton({ extended }: FormSkeletonProps) {
	return (
		<div className={styles.form}>
			<div className={styles['container-info']}>
				<div className={styles['flex-row']}>
					<div className={styles['flex-item']}>
						<div className={styles['flex-row']}>
							<FieldSkeleton
								labelText='Container'
								containerClassName={styles.container}
							/>

							<div className={`${styles['flex-item']} ${styles['size-flex-item']}`}>
								<span className={styles['label']}>Size</span>
								<Skeleton
									variant='text'
									width={50}
								/>
							</div>

							<div className={styles['flex-item']}>
								<span className={styles['label']}>Type</span>
								<Skeleton
									variant='text'
									className={styles['type']}
								/>
							</div>
						</div>
						<div className={styles['flex-row']}>
							<div className={`${styles.chassis} ${styles['flex-col']}`}>
								<span
									className={styles.label}
									style={{ paddingLeft: '8px' }}
								>
									Chassis
								</span>
								<div className={styles['driver']}>
									<Skeleton
										variant='rounded'
										width={220}
										height={36.5}
									/>
								</div>
							</div>

							<FieldSkeleton
								labelText='Is Owned'
								width={77}
								checkbox
							/>

							<FieldSkeleton
								labelText='Street Turn'
								width={85.5}
								checkbox
							/>
						</div>
					</div>
					<div className={`${styles['flex-item']} ${styles['steamship-info']}`}>
						<div className={styles['flex-row']}>
							<div className={styles['flex-item']}>
								<span className={styles['label']}>Vessel</span>
								<Skeleton
									variant='text'
									className={styles.vessel}
								/>
							</div>
						</div>

						<div className={styles['flex-row']}>
							<div className={styles['flex-item']}>
								<span className={styles['label']}>Voyage</span>
								<Skeleton
									variant='text'
									className={styles.voyage}
								/>
							</div>

							<div className={styles['flex-item']}>
								<Skeleton
									variant='text'
									className={styles.voyage}
								/>
							</div>
						</div>
					</div>
					<div className={styles['flex-item']}>
						<div className={styles['flex-row']}>
							{extended && (
								<>
									<FieldSkeleton
										labelText='Pieces'
										containerClassName={styles.pieces}
									/>

									<FieldSkeleton
										labelText='Weight (lb)'
										containerClassName={styles.pounds}
									/>

									<FieldSkeleton
										labelText='Weight (kg)'
										containerClassName={styles.kilograms}
									/>
								</>
							)}
						</div>

						<div className={styles['flex-row']}>
							{extended && (
								<FieldSkeleton
									labelText='Seal'
									containerClassName={styles.seal}
								/>
							)}
						</div>
					</div>
				</div>

				<div className={styles['flex-row']}>
					<FieldSkeleton
						labelText='Full Container Available'
						containerClassName={`${styles['date-input']} ${styles['full-available']}`}
					/>

					<FieldSkeleton
						labelText='Empty Container Available'
						containerClassName={`${styles['date-input']} ${styles['empty-available']}`}
					/>

					<FieldSkeleton
						labelText='Cutoff/LFD'
						containerClassName={`${styles['date-input']} ${styles['empty-available']}`}
					/>
				</div>
			</div>
		</div>
	);
}
